// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3f22c8a","header":"_5a47e96","body":"_038bc13","overlay":"_2ac57dd","rootDisplayBlock":"_a6791fc","bodyOpen":"_da6b407"};